var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    attrs: {
      "id": "app",
      "page": _vm.$route.path
    }
  }, [_c('div', {
    staticClass: "main relative"
  }, [_c('div', {
    staticClass: "main-content relative w-full h-full"
  }, [_c('div', {
    staticClass: "flex items-centet justify-between h-full"
  }, [_c('div', {
    staticClass: "cover relative w-[45%] hidden xl:!block"
  }, [_c('img', {
    staticClass: "block w-full h-full object-cover object-center",
    attrs: {
      "src": require(`/src/assets/images/imgLogin.57770d89.png`)
    }
  }), _c('div', {
    staticClass: "layer bg-layer bg-gradient-to-r from-[rgba(11_29_53_0.7)_1.46%] to-[rgba(11_29_53_0.6)_96.77%]"
  }, [_c('div', {
    staticClass: "flex items-center justify-center h-full"
  }, [_vm.$route.path == '/crm/' || _vm.$route.path == '/en/crm/' ? _c('AppCover', {
    attrs: {
      "heading1": "Welcome",
      "heading2": "Back",
      "title": "Already Existing Member?",
      "description": "Already a member? Transfer your point and account information now"
    }
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/crm/transfer-existing-account"
    }
  }, [_vm._v(_vm._s(_vm.$t('Transfer Existing Account')))])], 1) : _vm._e(), _vm.$route.path == '/crm/registration' || _vm.$route.path == '/en/crm/registration' ? _c('AppCover', {
    attrs: {
      "heading1": "Join",
      "heading2": "Overlander",
      "title": "Already Existing Member?",
      "description": "Already a member? Transfer your point and account information now"
    }
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/crm/transfer-existing-account"
    }
  }, [_vm._v(_vm._s(_vm.$t('Transfer Existing Account')))])], 1) : _vm._e(), _vm.$route.path == '/crm/transfer-existing-account' || _vm.$route.path == '/crm/two-step-authenication-one' || _vm.$route.path == '/crm/two-step-authenication-two' || _vm.$route.path == '/en/crm/transfer-existing-account' || _vm.$route.path == '/en/crm/two-step-authenication-one' || _vm.$route.path == '/en/crm/two-step-authenication-two' ? _c('AppCover', {
    attrs: {
      "heading1": "Join",
      "heading2": "Overlander",
      "title": "Need Help?"
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.$t('If you encounter any problems when transferring your account, please contact us')) + " "), _c('a', {
          attrs: {
            "href": "https://wa.me/85256901002",
            "target": "_blank"
          }
        }, [_vm._v("Whatsapp +852 56901002")])];
      },
      proxy: true
    }], null, false, 2375391979)
  }) : _vm._e()], 1)])]), _c('router-view')], 1)])])]);
};

var staticRenderFns = [];
export { render, staticRenderFns };